<template>
  <div
    id="mobile-menu-container"
    class="mobile-menu-container"
    :class="{ open: isMenuOpen, 'set-transparent-background': !isScrolled, 'unset-transparent-background': isScrolled }"
  >
    <div class="mobile-menu-header">
      <div class="mobile-menu-icon-container">
        <img
          @click="selectHomeOption('app')"
          :src="strongBowLogo"
          alt="logo de Strongbow"
        />
      </div>
      <div class="hamburguer-container">
        <div id="nav-icon3" :class="{ open: isMenuOpen, unscrolled: !isScrolled, scrolled: isScrolled }" @click="openMenu()">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="mobile-menu-row">
      <div class="mobile-menu-options-container">
        <div
          @click="selectMobileOption('flavors')"
          :class="{ active: getActiveSection === 'flavors' }"
          class="mobile-menu-option"
        >
          <h2>HOME</h2>
        </div>

        <!--<div
          @click="selectMobileOption('retailers')"
          :class="{ active: getActiveSection === 'retailers' }"
          class="mobile-menu-option"
        >
          <h2>DÓNDE COMPRAR</h2>
        </div>-->
        <div
          @click="selectMobileOption('goldApple')"
          :class="{ active: getActiveSection === 'goldApple' }"
          class="mobile-menu-option"
        >
          <h2>GOLD APPLE</h2>
        </div>
        <div
          @click="selectMobileOption('honey')"
          :class="{ active: getActiveSection === 'honey' }"
          class="mobile-menu-option"
        >
          <h2>HONEY</h2>
        </div>
        <div
          @click="selectMobileOption('redBerries')"
          :class="{ active: getActiveSection === 'redBerries' }"
          class="mobile-menu-option"
        >
          <h2>RED BERRIES</h2>
        </div>
        <div
          @click="selectMobileOption('roseApple')"
          :class="{ active: getActiveSection === 'roseApple' }"
          class="mobile-menu-option"
        >
          <h2>ROSÉ APPLE</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import strongBowLogo from "@/assets/Logo_Strongbow.png";

import { mapActions, mapGetters } from "vuex";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
  name: "MobileMenu",
  computed: {
    ...mapGetters(["getActiveSection"]),
  },
  methods: {
    ...mapActions({
      setActiveSection: "setActiveSection",
    }),
    socialClick(socialNetwork, action){
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
    },
    openMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    selectHomeOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
    },
    selectMobileOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
      this.$router.push({ name: option }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
      this.openMenu();
    },
  },
  data() {
    return {
      isMenuOpen: false,
      strongBowLogo,
      isScrolled: false,
      scrollLevel: 100
    };
  },
  mounted(){
window.onscroll= (() => {
   let onScroll = () => {
       if ( window.pageYOffset > this.scrollLevel && !this.isScrolled ) {
      this.isScrolled = true
    } else if (window.pageYOffset <=this.scrollLevel && this.isScrolled) {
      this.isScrolled = false
    }
    }
   onScroll();
   return onScroll
})()

}};
</script>

<style scoped lang="scss">
@import "~@/styles/mobilemenu.scss";
</style>
